import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28d2399b&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=28d2399b&prod&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=28d2399b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2399b",
  null
  
)

export default component.exports